import { getCoreDataSecurityUsageSlice } from './get';

export const { requestGetCoreDataSecurityUsage, resetGetCoreDataSecurityUsage } = getCoreDataSecurityUsageSlice.asyncActionCreators;
